import { Pipe, PipeTransform } from '@angular/core';
import { PartnerExtIdsModel } from '../../store';
import { TranslateService } from '@ngx-translate/core';
import { PartnerTypePipe } from './partner-type.pipe';

@Pipe({
  name: 'partnerDetails',
})
export class PartnerDetailsPipe implements PipeTransform {
  constructor(private translateService: TranslateService, private partnerTypePipe: PartnerTypePipe) {}
  transform({
    partnerName,
    partnerId,
    partnerExtIds,
  }: {
    partnerName: string;
    partnerId: number;
    partnerExtIds: PartnerExtIdsModel[];
  }): string {
    if (!partnerExtIds && !partnerName && !partnerId) {
      return '';
    }

    const partnerNameRow = `${this.translateService.instant('common.field.partnerName')} : ${partnerName}`;
    const partnerIdRow = `${this.translateService.instant('common.field.partnerId')} : ${partnerId}`;
    const partnerExtIdsRows = (partnerExtIds || []).map((partnerExtId: PartnerExtIdsModel) => {
      return `${this.partnerTypePipe.transform(partnerExtId.type)} : ${partnerExtId.id}`;
    });
    return [partnerNameRow, partnerIdRow, ...partnerExtIdsRows].join('\n');
  }
}
